import { render, staticRenderFns } from "./ContainerDynamic.vue?vue&type=template&id=55f7bfa2&"
import script from "./ContainerDynamic.vue?vue&type=script&lang=js&"
export * from "./ContainerDynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports